import { FETCH_COUNTRIES_LIST} from "../actionTypes";
import { fetchCountriesList } from "../../../api/newService/serviceCountries.service";

const request = () => ({ type: FETCH_COUNTRIES_LIST.REQUEST });
const failure = (error) => ({ type: FETCH_COUNTRIES_LIST.FAILURE,error });
const success = (data) => ({ type: FETCH_COUNTRIES_LIST.SUCCESS,data});

export const getContriesList = () => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchCountriesList()
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
